import { Receipt } from "@mui/icons-material";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Pagination,
    Paper,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Typography,
    useMediaQuery,
} from "@mui/material";
import dayjs from "dayjs";
import { useLayoutEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useOrganizationStore } from "../../../store/organization.store";
import { FeedbacksReasons } from "../../../configs/feedbacks-reasons.config";
import {
    FormDataSubmit,
    Organization,
} from "../../../types/Store/OrganizationStore.types";
import FeedbackDialog from "./TicketsDialog";
import { useTicketsStore } from "../../../store/tickets.store";
import { Ticket } from "../../../types/Store/TicketsStore.types";
import { TicketsStatus } from "../../../configs/tickets-status";

export function TicketsPage() {
    const [loadingPage, setLoadingPage] = useState(false);
    const isMobile = useMediaQuery("(max-width:1100px)");
    const isSmallMobile = useMediaQuery("(max-width:700px)");

    const { getTickets, createTicket } = useTicketsStore();

    const [tickets, setTickets] = useState<Ticket[]>([]);
    const [ticketCount, setTicketCount] = useState(0);

    const [loadingSend, setLoadingSend] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const [page, setPage] = useState(1);
    const [order, setOrder] = useState<"asc" | "desc">("desc");

    const handleSortDate = () => {
        setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    };
    const getData = async () => {
        try {
            setLoadingPage(true)
            const data = await getTickets(page - 1, order.toUpperCase());
            if (data && Array.isArray(data) && data.length >= 2) {
                setTickets(data[0] || []);
                setTicketCount(data[1] || 0);
            } else {
                setTickets([]);
                setTicketCount(0);
            }
        } catch (error) {
            setTickets([]);
            setTicketCount(0);
        } finally {
            setLoadingPage(false)
        }
    };

    useLayoutEffect(() => {
        getData();
    }, [page, order]);

    const handleSubmitForm = async (data: FormDataSubmit) => {
        console.log("I SEND", data);
        try {
            setLoadingSend(true);
            await createTicket(data.title, data.description, data.file || null);
            setPage(1);
            await getData();
        } catch (error) {
        } finally {
            setOpenDialog(false);
            setLoadingSend(false);
        }
    };

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: isSmallMobile ? "stretch" : "center",
                    marginBottom: "30px",
                    flexDirection: isSmallMobile ? "column" : "row",
                }}
            >
                <h1>Обращения</h1>
                <Button variant="contained" onClick={() => setOpenDialog(true)}>
                    Новое обращение
                </Button>
            </Box>
            <TableContainer
                component={Paper}
                sx={{
                    maxWidth: isMobile ? "calc(100vw - 48px)" : "100%",
                    overflowX: "auto",
                }}
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sortDirection={order}>
                                <TableSortLabel
                                    active
                                    direction={order}
                                    onClick={handleSortDate}
                                >
                                    Дата
                                </TableSortLabel>
                            </TableCell>
                            {!isSmallMobile && <TableCell>Заголовок</TableCell>}
                            {!isSmallMobile && <TableCell>Статус</TableCell>}
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    {loadingPage ? (
                        <TableBody>
                            {Array(10)
                                .fill(10)
                                .map((n, v) => {
                                    return (
                                        <TableRow key={v}>
                                            <TableCell>
                                                <Skeleton variant="text" />
                                            </TableCell>
                                            {!isSmallMobile && (
                                                <TableCell align="center">
                                                    <Skeleton
                                                        variant="text"
                                                        style={{
                                                            marginLeft: "auto",
                                                            display:
                                                                "inline-block",
                                                            width: "100px",
                                                        }}
                                                    />
                                                </TableCell>
                                            )}
                                            {!isSmallMobile && (
                                                <TableCell align="center">
                                                    <Skeleton
                                                        variant="text"
                                                        style={{
                                                            marginLeft: "auto",
                                                            display:
                                                                "inline-block",
                                                            width: "100px",
                                                        }}
                                                    />
                                                </TableCell>
                                            )}
                                            <TableCell align="right">
                                                <Skeleton
                                                    variant="text"
                                                    style={{
                                                        marginLeft: "auto",
                                                        display: "inline-block",
                                                        width: "140px",
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    ) : (
                        <TableBody>
                            {(tickets || []).map((row, i) => (
                                <TableRow key={row.id}>
                                    {/* {JSON.stringify(row)} */}
                                    <TableCell>
                                        {isSmallMobile ? (
                                            <>
                                                <Typography>
                                                    {TicketsStatus[row.status]}
                                                </Typography>
                                                <Typography variant="caption">
                                                    {dayjs(
                                                        row.created_at,
                                                    ).format("DD.MM.YYYY")}
                                                </Typography>
                                            </>
                                        ) : (
                                            dayjs(row.created_at).format(
                                                "DD.MM.YYYY",
                                            )
                                        )}
                                    </TableCell>
                                    {!isSmallMobile && (
                                        <TableCell>{row.title}</TableCell>
                                    )}
                                    {!isSmallMobile && (
                                        <TableCell>
                                            {TicketsStatus[row.status]}
                                        </TableCell>
                                    )}
                                    <TableCell align="right">
                                        <Link
                                            to={
                                                "/admin/tickets/detailed?id=" +
                                                row.id
                                            }
                                        >
                                            Подробнее
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    )}
                </Table>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Pagination
                        sx={{
                            marginTop: "16px",
                            marginBottom: "16px",
                        }}
                        count={
                            Math.floor(ticketCount / 10) +
                            (ticketCount % 10 == 0 ? 0 : 1)
                        }
                        page={page}
                        onChange={(e, p) => setPage(p)}
                    />
                </Box>
            </TableContainer>
            <FeedbackDialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                onSubmit={handleSubmitForm}
                loading={loadingSend}
            />
        </Box>
    );
}
